<p-toast [key]="toastKey"> </p-toast>
<div class="employeeTrainingPlan">
    <div class="flex card-container">
      <div class="label-wrapper">
        <label>User</label>
      </div>
      <div class="flex flex-row scope-wrapper">
      <div class="tree-wrapper">
        <p-treeSelect
          selectionMode="single"
          class="w-full"
          [(ngModel)]="selectedUser"
          [options]="userTreeData"
          [style]="{ 'width': '100%' }"
          [ngClass]="{'red': userWithTerminatedStatusSelected}"
          (onNodeSelect)="handleTreeSelectChange($event)"
          [filter]="true"
          ></p-treeSelect>
      </div>
      
      <div class="flex grid" [ngClass]="{ 'enabled-gridClass': selectedUser }">
        <div class="col-grow"></div>
        <div class="col-fixed">
            <bpt-file-upload
                [uploadFiles]="uploadSucceeds"
                [fileTypes]="''"
                [maxSize]="maxFileSize"
                [disabled]="!userSelected"
                [fileLimit]="userProfileAttachmentMaxLimit">
            </bpt-file-upload>
        </div>
        <div class="col-fixed editButton">
            <p-button
                styleClass="p-button-outlined"
                icon="fa fa-pen"
                id="editUserProfileBtn"
                class="edit-User-Profile-Button"
                pTooltip="Edit User Profile"
                tooltipPosition="left"
                iconPos="left"
                [disabled]="!userSelected"
                (onClick)="editUserProfile()">
            </p-button>
        </div>
        <div class="col-fixed editButton" *ngIf="canAssignSkills">
            <p-button
                styleClass="p-button-outlined"
                icon="fa-solid fa-award"
                id="assignSkillsBtn"
                class="assign-skills-button"
                pTooltip="Assign Skills"
                tooltipPosition="left"
                iconPos="left"
                [disabled]="!userSelected || userWithTerminatedStatusSelected"
                (onClick)="openAssignSkillsSlider()">
            </p-button>
        </div>
        <div class="col-fixed editButton" *ngIf="canAssignSkills">
            <p-button
                styleClass="p-button-outlined"
                icon="pi pi-history"
                id="auditTrailBtn"
                class="audit-trail-button"
                pTooltip="Audit Trail"
                tooltipPosition="bottom"
                iconPos="left"
                [disabled]="!userSelected || userWithTerminatedStatusSelected"
                (onClick)="openUserProfileAuditModal()">
            </p-button>
        </div>
    </div>
      </div>
      
    </div>
    <div *ngIf="selectedUser != null">
    <app-user-profile-details [userProfile]="userProfile" [userAssignedSkills]="userAssignedSkills" [treeData]="treeData"></app-user-profile-details>
    </div>
<app-user-profile-slider [isUserProfileSliderOpen]="isUserProfileSliderOpen" [userPUIDForEdit]="userPUIDForEdit" (closeUserProfileSlider)="reloadUserData()"> </app-user-profile-slider>
<app-assign-skills-slider *ngIf="isAssignSkillsSliderOpen" [isAssignSkillsSliderOpen]="isAssignSkillsSliderOpen" [userPUID]="selectedPuid" (assignSkillsSliderClosed)="closeAssignSkillsSlider($event)"></app-assign-skills-slider>

<app-user-profile-audit-modal 
    [isShowUserProfileAuditModal]="isShowUserProfileAuditModal"
    [auditTrailData]="auditTrailData" 
    [userName]="userProfile.fullName" 
    (closeModal)="closeUserProfileAuditModal($event)">
</app-user-profile-audit-modal> 
</div>
